import { getMessage } from 'common/helpers/miscHelper';

const Questions = (props) => {
  const { settings } = props;
  return (
    <p className="c7-message c7-message--login-questions">
      {getMessage('Login Help', settings)}
    </p>
  );
};

export default Questions;
